exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EhS8BAqGZFQD-VG59vKqh{padding-top:20px}.n6IupRr2eY16v4jJ6rt8-{position:absolute}._12fYNSW0q_nr_CxnsW_Ug-{padding-left:20px;padding-right:20px;padding-bottom:20px}.yVdLZ_LMEKHF3twfPGapP{margin-top:15px;display:flex;flex-flow:row wrap;align-items:center}.yVdLZ_LMEKHF3twfPGapP ._2CNA11cm6biaSG7ICqxqGO{flex:1 0 100%;margin:0px 10px 10px 0px}.yVdLZ_LMEKHF3twfPGapP ._2CNA11cm6biaSG7ICqxqGO input{margin:0px}.yVdLZ_LMEKHF3twfPGapP a._3f_AayanWeU-AxndALLlEa{margin:0px 0px 0px 10px}._1Q_kurrLfC2cE13wStt5eW{margin-right:5px;margin-bottom:3px}._1xc9Fzp6tg5aM4hfpKBahU{margin-right:5px}._1ud9HFWkY6ksxs2bQVEbfB{border-top:1px solid #e0e0e0}._1qKHbIpaW7XIB33wpiU5uo{background-color:#eee}\n", ""]);

// Exports
exports.locals = {
	"card": "EhS8BAqGZFQD-VG59vKqh",
	"gpliPortal": "n6IupRr2eY16v4jJ6rt8-",
	"addSection": "_12fYNSW0q_nr_CxnsW_Ug-",
	"addSectionForm": "yVdLZ_LMEKHF3twfPGapP",
	"input": "_2CNA11cm6biaSG7ICqxqGO",
	"addSectionButton": "_3f_AayanWeU-AxndALLlEa",
	"addSectionIcon": "_1Q_kurrLfC2cE13wStt5eW",
	"addSectionSpinner": "_1xc9Fzp6tg5aM4hfpKBahU",
	"Guide": "_1ud9HFWkY6ksxs2bQVEbfB",
	"isDragging": "_1qKHbIpaW7XIB33wpiU5uo"
};